import { IEventData } from 'meta/pages/v4/event'
import { IEventCollectionData } from 'meta/pages/v4/eventCollection'

export const mergeEventAndCollectionDataIntoEventData = (
  event: IEventData,
  eventCollection: IEventCollectionData
): IEventData => {
  const mergedData: IEventData = {
    ...event,
    id: eventCollection.id,
    name: eventCollection.name,
    codeUrl: eventCollection.codeUrl,
    code: eventCollection.code,
    longDescription: eventCollection.longDescription,
    assets: eventCollection.assets,
  }

  return mergedData
}
